module.exports = __webpack_public_path__ + "static/media/prayer-timetable.dc3cb152.jpeg";